import React from 'react'
import PropTypes from 'prop-types'
import {Link as SPALink, NavLink as NavSPALink} from 'react-router-dom'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const Link = React.forwardRef(({href, to, useNavLink = false, className, ...props}, ref) => {
    const _href = to || href
    const {buildUrl} = useMultiSite()
    const updatedHref = buildUrl(_href)
    const Component = useNavLink ? NavSPALink : SPALink

    return (
        <Component
            {...(useNavLink && {exact: true})}
            {...props}
            className={className}
            to={updatedHref}
            ref={ref}
        />
    )
})

Link.displayName = 'Link'

Link.propTypes = {
    href: PropTypes.string,
    to: PropTypes.string,
    useNavLink: PropTypes.bool,
    className: PropTypes.string
}

export default React.memo(Link)
